import { Button as AntButton } from "antd";
import styled from "styled-components";

const Styled = styled(AntButton)`
  ${(_) => `
   &:hover {
    border-color: ${
      _.disabled ? _.theme.token.actions.disable : _.color
    } !important;
   }
   &.tertiary-color {
    color: ${!_.type ? _.color : _.theme.token.colorPrimary} !important;
   }
   height: 4rem;
   min-width: ${_.minWidth || "12rem"};
   color: white !important;
   color: ${_.color} !important;
   border-color: ${_.color};
   background: transparent !important;
  ${
    _.disabled &&
    `background: ${_.theme.token.actions.disable} !important;
    border-color: ${_.theme.token.actions.disable} !important;
    color: white !important;`
  };
  ${
    !!_.type &&
    !_.disabled &&
    `color: white !important;
    background: ${_.color} !important;`
  };
  ${
    _.success &&
    `background: ${_.theme.token.success};
    &:hover {
      background: ${_.theme.token.success} !important;
      opacity: .9;
    }`
  };
  `}
`;

export default Styled;
